import { render, staticRenderFns } from "./swiper-button-quarternary.vue?vue&type=template&id=825cd600&scoped=true&"
import script from "./swiper-button-quarternary.vue?vue&type=script&lang=js&"
export * from "./swiper-button-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825cd600",
  null
  
)

export default component.exports